import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import MaterialTable, { MTablePagination } from "material-table";
import { Row, Col, Form } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import { TablePagination } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import Search from "@mui/icons-material/Search";
import ViewColumn from "@mui/icons-material/ViewColumn";
import CheckRole from "../../CheckRole.js";
import AADService from "../../funcionesAuth.js";
import { IoMdDownload } from "react-icons/io";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar } from "@mui/material";
import { DecryptData } from "../../DatosEncriptados/EncryptedFunctions";
import XLSX from "xlsx";
import PikachuComponent from "./loadingComponent.js";
import AnimatedGifComponent from "./AnimatedGifComponent.js";
import ModalActualizarAnalista from "./ModalActualizarAnalista.js";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
//import PercentIcon from '@mui/icons-material/Percent';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const tableIcons = {
  //Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function Mtable_NewEvaluaciones(params) {
  //Establece estilos de componentes
  const useStyles = makeStyles((theme) => ({
    container: {
      maxHeight: "55vh",
      minHeight: "55vh",
    },
    root: {
      width: "100%",
    },
    pagination: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    switch: {
      paddingLeft: "1.5em",
    },
    inside: {
      backgroundColor: "white",
      width: "100%",
      //margintom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: "#2c2a29",
      color: "white",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    palette: {
      primary: {
        main: "#4caf50",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  }));

  //Modifica temas predeterminados por Material-Table
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2c2a29",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  });
  const renderBoolIcon = (val) => {
    const lower = val?.toLowerCase();
    return lower === "si" ? (
      <CheckIcon style={{ color: "#4CAF50" }} /> // Verde más suave
    ) : lower === "no" ? (
      <ClearIcon style={{ color: "#F44336" }} /> // Rojo menos brillante
    ) : (
      val || "-"
    );
  };
  const colores = {
    0: "#F44336", // Rojo
    33.33: "#FF9800", // Naranja
    66.66: "#FFEB3B", // Amarillo
    100: "#4CAF50", // Verde
  };

  const renderPorcentajeFijo = (val) => (
    <>
      <span style={{ color: colores[val], fontWeight: "bold", marginRight: 4 }}>
        {val} %
      </span>
      {/* <PercentIcon style={{ color: colores[val], fontSize: 20 }} /> */}
    </>
  );
  var columns = [
    {
      field: "idevaluacion",
      title: "Id evaluación",
    },
    {
      field: "nombre",
      title: "Nombre",
    },
    {
      field: "idactivo",
      title: "Id Activo",
    },
    // {
    //   field: "estado_evaluacion",
    //   title: "estado_evaluacion",
    //   render:(rowData)=> rowData.estado_evaluacion === 1 ? "Activo" : "Inactivo"
    // },
    {
      field: "validadorero",
      title: "Validador ERO",
    },
    {
      field: "analista",
      title: "Analista",
    },
    {
      field: "fechamodificacion",
      title: "Fecha Modificacion",
      // mostrar la fecha de la siguiente manera 2021-08-20
      render: (rowData) =>
        rowData.fechaaprobacion
          ? rowData.fechaaprobacion.split("T")[0]
          : "SIN FECHA",
    },
    //mostrar con iconos
    {
      field: "control",
      title: "Control",
      render: (rowData) => renderBoolIcon(rowData.control),
    },
    {
      field: "vulnerabilidad",
      title: "Vulnerabilidad",
      render: (rowData) => renderBoolIcon(rowData.vulnerabilidad),
    },
    {
      field: "efectos",
      title: "Efectos",
      render: (rowData) => renderPorcentajeFijo(rowData.efectos),
    },
  ];
  // {
  //   field: "idactivo",
  //   title: "idactivo",
  // },
  // {
  //   field: "idcompania",
  //   title: "idcompania",
  // },
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const renderLoading = () => <PikachuComponent />;
  const classes = useStyles();
  const [loadingComponent, setLoadingComponent] = useState(false);
  const [evaluacion, setEvaluacion] = useState([]); //table data
  const [selected, setSelected] = React.useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ButtonEdit, SetButtonEdit] = React.useState(false);
  const [filter, setFilter] = useState(false);
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const check = new CheckRole("/new-evaluaciones");
  const [activoEvaluar, setActivoEvaluar] = React.useState(0);
  const checkEvaluaciones = new CheckRole("/detalle-evaluacion");
  const [loading, setLoading] = React.useState(false);
  const [evaluacionxRiesgo, setEvaluacionxRiesgo] = React.useState([]);
  const [currentRol, setCurrentRol] = useState(null);
  const [buttonDelete, setButtonDelete] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [dataLideres, setDataLideres] = useState([]);
  const idCompania = localStorage.getItem("idcompania");

  const decodeEmail = (encodedEmail) => {
    const decodedBuffer = Buffer.from(encodedEmail, "base64");
    const decodedString = decodedBuffer.toString("ascii");
    const charCodes = decodedString.split("/");
    let decodedEmail = "";
    for (let i = 1; i < charCodes.length; i++) {
      decodedEmail += String.fromCharCode(parseInt(charCodes[i]));
    }
    return decodedEmail;
  };

  const fetchdata = async (rol, formattedTime) => {
    setLoading(true);
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "evaluacion/nuevaevaluacion/" +
      localStorage.getItem("idcompania") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (result.status >= 200 && result.status <= 300) {
      setLoading(false);
      let data = await result.json();
      localStorage.setItem("eval_type", 1);

      if (rol === 1 || rol === 2 || rol === 7 || rol === 8 || rol === 10) {
        setEvaluacion(data);
      } else {
        const resultUsuario = await fetch(
          process.env.REACT_APP_API_URL +
          "usuariosrol/" +
          localStorage.getItem("idcompania") +
          "/" +
          rol,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        let dataUsuario = await resultUsuario.json();
        let evaluaciones = [];

        var posicionUsuario = 0;
        const userEmailEncoded = localStorage.getItem("usuario");
        const userEmail = decodeEmail(userEmailEncoded);

        for (let i = 0; i < dataUsuario.length; i++) {
          if (dataUsuario[i].email === userEmail) {
            posicionUsuario = dataUsuario[i].idposicion;
            break;
          }
        }

        for (let i = 0; i < data.length; i++) {
          if (
            data[i].responsableti === posicionUsuario ||
            data[i].responsablenegocio === posicionUsuario
          ) {
            evaluaciones.push(data[i]);
          }
        }

        setEvaluacion(evaluaciones);
      }
    } else if (result.status >= 400 && result.status <= 500) {
      setLoading(false);
      setLoadingComponent(true);
      setEvaluacion([]);
    }
  };
  useEffect(() => {
    const obtenerLideresEvidencia = async () => {
      const url = `${process.env.REACT_APP_API_URL
        }general/parametrosGeneralesxGrupoxParametro/Adjuntos/${localStorage.getItem(
          "idcompania"
        )}/`;

      const result = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      });
      if (result.status >= 200 && result.status <= 300) {
        let datLideres = await result.json();
        const mapLideres = datLideres.map((lider) => {
          return {
            vlrmetrica: lider.vlrmetrica,
          };
        });
        setDataLideres(mapLideres);
      }
      if (result.status >= 400 && result.status <= 500) {
        setDataLideres([]);
      }
    };
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuarios/menu/" +
        localStorage.getItem("usuario") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = usuario.map((user) => {
        return {
          opcion: user.url_opcion,
          permisos: user.permisos.split(";"),
        };
      });
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "GET");

      if (validity) {
        //fetchdata(usuario[0].idrol);
        setCurrentRol(usuario[0].idrol);
      }
    };
    const time = new Date();
    const formattedTime =
      String(time.getDate()).padStart(2, "0") +
      "/" +
      String(time.getMonth() + 1).padStart(2, "0") +
      "/" +
      time.getFullYear() +
      " " +
      String(time.getHours()).padStart(2, "0") +
      ":" +
      String(time.getMinutes()).padStart(2, "0") +
      ":" +
      String(time.getSeconds()).padStart(2, "0");
    fetchdata(parseInt(localStorage.getItem("rolusuario")), formattedTime).then(
      () => {
        obtenerLideresEvidencia();
      }
    );
    fetchUsuario();
  }, []);
  const fetchdataEvaluacionxRiesgo = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "informes/" +
      localStorage.getItem("idcompania") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (result.status >= 200 && result.status <= 300) {
      let data = await result.json();
      return data;
    } else if (result.status >= 400 && result.status <= 500) {
      return result.status;
    }
  };
  const handleClick = (id, idactivo) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], id);
      SetButtonEdit(true);
      setButtonDelete(true);
    } else {
      SetButtonEdit(false);
      setButtonDelete(false);
    }
    setSelected(newSelected);
    setActivoEvaluar(idactivo);
  };

  const editar = (event, props) => {
    localStorage.setItem("idevaluacion", selected);
    localStorage.setItem("idactivo", activoEvaluar);
    params.params.action();
  };

  function add_eval() {
    localStorage.setItem("idevaluacion", 0);
  }

  //Habilita y desabilita los filtros por columnas
  const handleChange = () => {
    setFilter(!filter);
  };
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOnExport = (data) => {
    const newBook = XLSX.utils.book_new();

    const sheet1 = XLSX.utils.json_to_sheet(data["resumen"] || []);
    const sheet2 = XLSX.utils.json_to_sheet(data["efectos_asociados"] || []);

    const date = new Date();
    const formattedDate =
      String(date.getDate()).padStart(2, "0") +
      "_" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "_" +
      date.getFullYear();

    XLSX.utils.book_append_sheet(newBook, sheet1, "InformeEROS");
    XLSX.utils.book_append_sheet(newBook, sheet2, "Efectos Asociados");
    XLSX.writeFile(newBook, "InformeEROS_" + formattedDate + ".xlsx");
  };


  const handleExportClick = async () => {
    try {
      setSnackbarOpen(true);
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const data = await fetchdataEvaluacionxRiesgo();
      if (data) {
        handleOnExport(data);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setSnackbarOpen(false);
    }
  };

  return (
    <div className={classes.root}>
      {/* <div>{loadingComponent && renderLoading()}</div>
      <div> {loadingComponent && <AnimatedGifComponent />}</div> */}
      <Row className="pl-3 pt-3 pb-3" style={{ alignItems: "center" }}>
        <Col sm={8}>
          <h2 className="titulo">Nuevas Evaluaciones</h2>
        </Col>
        <Col sm={4} className="text-right">
          {(
            dataLideres.some(
              (lider) => lider.vlrmetrica == localStorage.getItem("idusuario")
            ) || localStorage.getItem("idrol") === "1"
          ) && (
              <Button
                className="botonPositivo"
                style={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  borderRadius: "8px",
                  height: "40px",
                  minWidth: "200px",
                  padding: "0 20px",
                  fontWeight: "500",
                  textTransform: "none",
                  fontSize: "14px",
                }}
                onClick={handleOpenModal}
              >
                Actualizar Analista Masivo
              </Button>
            )}

        </Col>
      </Row>

      <Paper variant="outlined" className={classes.paper}>
        <MuiThemeProvider theme={theme}>
          <MaterialTable
            columns={columns}
            data={evaluacion}
            icons={tableIcons}
            options={{
              rowStyle: (rowData) => ({
                backgroundColor:
                  ButtonEdit === true && selectedRow === rowData.tableData.id
                    ? "#fff8d3"
                    : "#FFF",
              }),
              showTitle: false,
              filtering: filter,
              searchFieldAlignment: "left",
              searchFieldStyle: {}, //Llenar estilo de barra de busqueda
              headerStyle: {
                backgroundColor: "#2c2a29",
                color: "#ffffff",
                position: "sticky",
                top: 0,
                fontFamily: "CIBFont Sans Regular",
                fontWeight: 400,
                fontSize: "1.2rem",
                lineHeight: 1.6,
                letterSpacing: "0.0075em",
                flex: "1 1 100%",
              },
              maxBodyHeight: "650px",
              selection: false,
              disableMultipleSelection: true,
              pageSizeOptions: [10, 20, 30],
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 10,
            }}
            components={{
              Pagination: (props) => (
                <div className={classes.pagination}>
                  <FormControlLabel
                    className={classes.switch}
                    control={
                      <Checkbox
                        checked={filter}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Mostrar filtros por columnas
                      </Typography>
                    }
                  />
                  <TablePagination {...props} className={classes.pagination} />
                </div>
              ),
            }}
            onRowClick={(evt, selectedRow) => {
              handleClick(selectedRow.idevaluacion, selectedRow.idactivo);
              return setSelectedRow(selectedRow.tableData.id);
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    {check.checkPermits(opcionesGenerales, "PUT") ? (
                      <Button
                        className="botonPositivo"
                        onClick={handleExportClick}
                        disabled={loading}
                        style={{
                          backgroundColor: "#4caf50",
                          color: "#fff",
                          borderRadius: "8px",
                          height: "40px",
                          minWidth: "200px",
                          padding: "0 20px",
                          fontWeight: "500",
                          textTransform: "none",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Informe Evaluaciones
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                ),
                position: "toolbar",
                isFreeAction: true,
              },
              {
                icon: () => (
                  <Link to="EditarEvaluacion">
                    {check.checkPermits(opcionesGenerales, "PUT") ? (
                      <Button
                        style={{
                          backgroundColor: "#a9a9a9",
                          color: "#fff",
                          borderRadius: "5px",
                          height: "40px",
                          minWidth: "100px",
                        }}
                      >
                        Editar
                      </Button>
                    ) : (
                      ""
                    )}
                  </Link>
                ),
                onClick: () => editar(),
                position: "toolbar",
                isFreeAction: true,
                hidden: ButtonEdit === false,
              },
            ]}
            localization={{
              toolbar: {
                searchPlaceholder: "Buscar",
              },
              body: {
                emptyDataSourceMessage:
                  "Se está cargando la información desde la CMDB",
              },
              pagination: {
                labelRowsSelect: "Filas",
                firstTooltip: "Primera página",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Última página",
              },
            }}
          />
          <ModalActualizarAnalista
            open={openModal}
            handleClose={handleCloseModal}
          />
        </MuiThemeProvider>
      </Paper>
      <Snackbar
        open={snackbarOpen}
        message="Generando informe, espera por favor (aprox 20s)"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        ContentProps={{
          sx: {
            fontSize: "1.2rem",
            padding: "20px",
            minWidth: "400px",
            justifyContent: "center",
            backgroundColor: "#333", // opcional para estilo
          },
        }}
      />
    </div>
  );
}

export default Mtable_NewEvaluaciones;
